import {PlaceOrderRequestBody} from '@app/model/order/dcp-place-order-body.model';
import {HttpErrorResponse} from '@angular/common/http';
import {StripeErrorCode} from '@app/payment/services/error-handling/stripe-error-code.enum';

export enum StripeActionTypes {
  StartStripePaymentFlow = '[Stripe] Start Stripe payment flow',
  CreatePaymentIntent = '[Stripe] Create payment intent',
  CreatePaymentIntentSuccess = '[Stripe] Payment intent is created successfully',
  CreatePaymentIntentFailure = '[Stripe] Payment intent has not been created due to error',
  PaymentIntentNotRequired = '[Stripe] Payment intent is not required',
  Invoke3ds = '[Stripe] Invoke optional 3DS',
  Invoke3dsFailure = '[Stripe] 3DS check failure',
}

export class StartStripePaymentFlow {
  readonly type = StripeActionTypes.StartStripePaymentFlow;
}

export class CreatePaymentIntent {
  readonly type = StripeActionTypes.CreatePaymentIntent;
}

export class CreatePaymentIntentSuccess {
  readonly type = StripeActionTypes.CreatePaymentIntentSuccess;

  constructor(public payload: PlaceOrderRequestBody) {}
}

export class CreatePaymentIntentFailure {
  readonly type = StripeActionTypes.CreatePaymentIntentFailure;

  constructor(public payload: HttpErrorResponse) {}
}

export class PaymentIntentNotRequired {
  readonly type = StripeActionTypes.PaymentIntentNotRequired;
}

export class Invoke3ds {
  constructor(public payload: PlaceOrderRequestBody) {}

  readonly type = StripeActionTypes.Invoke3ds;
}

export class Invoke3dsFailure {
  public payload;
  readonly type = StripeActionTypes.Invoke3dsFailure;

  constructor(threeDsResponse: any) {
    const errorCode =
      threeDsResponse?.error?.code === 'payment_intent_authentication_failure'
        ? StripeErrorCode.PAYS_006
        : StripeErrorCode.DEFAULT;
    this.payload = {
      error: {
        raw: threeDsResponse,
        errors: [
          {
            errorCode,
            message: threeDsResponse?.error?.message,
          },
        ],
      },
    };
  }
}

export type StripeActions =
  | StartStripePaymentFlow
  | CreatePaymentIntent
  | CreatePaymentIntentSuccess
  | CreatePaymentIntentFailure
  | PaymentIntentNotRequired
  | Invoke3ds
  | Invoke3dsFailure;
